import React, { useState } from 'react';
import {
    Box,
    Typography,
    Button,
    Stack,
    Paper,
    Divider,
    Chip,
    Menu, MenuItem, alpha
} from '@mui/material';
import {
    Google as GoogleIcon,
    CheckCircle,
    Add,
    AccessTime,
    Sync,
    Settings,
    Note,
    CalendarToday,
    Launch,
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { disconnectCalendarByIdRequest } from 'src/modules/auth/store/authActions';
import { getGoogleAuthUrlRequest } from 'src/modules/app/store/appActions'
import { Close } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useTheme } from '@mui/material';
import { ReactComponent as Calendar } from 'src/assets/images/google-calendar.svg';
import { ReactComponent as More } from 'src/assets/images/more.svg';
import { getUserFromToken } from 'src/DecodeToken';

const GoogleCalendarIntegrationPage = ({ onClose }) => {
    const dispatch = useDispatch();
    const isGoogleConnected = useSelector(state => state.auth.user?.isGoogleConnected);
    const googleEmail = useSelector(state => state.auth.user?.googleEmail);
    const userEmail = useSelector(state => state.auth.user?.email);
    const token = sessionStorage.getItem('token');
    const theme = useTheme();
    const doctorId = getUserFromToken();

    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleMenuOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleConnect = () => {
        dispatch(
            getGoogleAuthUrlRequest(
                token,
                (res) => (window.location.href = res.url),
                (err) => console.error('Google Connect Failed:', err)
            )
        );
    };

    const handleDisconnect = () => {
        dispatch(
            disconnectCalendarByIdRequest(
                doctorId,
                (res) => {
                    console.log('Disconnected successfully', res);
                },
                (err) => {
                    console.error('Failed to disconnect:', err);
                }
            )
        );
        handleMenuClose();
    };

    return (
        <Box bgcolor="#f9f9f9" color="black">
            <IconButton
                onClick={onClose}
                size="small"
                sx={{ position: 'absolute', top: 8, right: 8 }}
            >
                <Close />
            </IconButton>
            <Box flex={1} p={4} overflow="auto">
                <Box sx={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>

                    <Calendar />
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>

                        <Typography variant="h3" gutterBottom>
                            Google Calendar
                        </Typography>
                        <Typography variant="small" color="text.secondary">
                            Sync between Google Calendar and your workspace.
                        </Typography>
                    </Box>

                </Box>
                <Paper
                    sx={{
                        backgroundColor: 'white',
                        color: 'black',
                        mt: 3,
                        p: 3,
                        borderRadius: 2,
                        border: '1px solid #e0e0e0',
                        position: 'relative',
                    }}
                >
                    <Stack direction="column" alignItems="center" justifyContent="space-around" spacing={0} sx={{
                        borderRadius: 2,
                        padding: '10px',
                        border: '1px solid #e0e0e0',
                    }}>
                        {/* <GoogleIcon fontSize="large" /> */}
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '430px' }}>
                            <Typography>{isGoogleConnected ? googleEmail : ''}</Typography>
                            <Button
                                variant="outlined"
                                startIcon={<Add />}
                                onClick={handleConnect}
                                sx={{ color: 'black', borderColor: '#ccc' }}
                            >
                                {isGoogleConnected ? 'Connect another account' : 'Connect account'}
                            </Button>
                        </Box>
                        <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', width: '430px', marginTop: '1px' }}>
                            {isGoogleConnected ? (
                                <Chip
                                    label="Connected"
                                    color="success"
                                    icon={<CheckCircle />}
                                    size="small"
                                    sx={{ mt: 1 }}
                                />
                            ) : (
                                <Button
                                    variant="outlined"
                                    size="small"
                                    color="error"
                                    disabled
                                    sx={{ mt: 1 }}
                                >
                                    Not Connected
                                </Button>
                            )}

                            <IconButton onClick={handleMenuOpen}>
                                <More />
                            </IconButton>
                            <Menu
                                anchorEl={anchorEl}
                                open={open}
                                onClose={handleMenuClose}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'right',
                                }}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'right',
                                }}
                                sx={{
                                    "& .MuiPaper-root": {
                                        width: "156px",
                                        // height: "212px",
                                        borderRadius: "12px",
                                        // boxShadow: theme.shadows[1],
                                        // padding: "4px 18px",
                                        backgroundColor: "red",
                                        border: `1px solid ${alpha(theme.palette.gery.black, 0.1)}`,
                                        backgroundColor: theme.palette.gery.white,
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        gap: '14px',
                                    }
                                }}
                            >
                                <MenuItem onClick={handleDisconnect}>Disconnect</MenuItem>
                            </Menu>
                        </Box>
                    </Stack>

                    <Divider sx={{ my: 3, borderColor: '#e0e0e0' }} />

                    <Stack spacing={3}>
                        <FeatureBlock
                            title="Sync tasks to calendar"
                            description="See tasks from a space, folder or list to a calendar in Google Calendar."
                            icon={<CalendarToday color="primary" />}
                        />
                        <FeatureBlock
                            title="Launch your Next Meeting"
                            description="Open Command Bar and hit Enter to launch your next meeting."
                            icon={<AccessTime color="primary" />}
                        />
                        <FeatureBlock
                            title="Realtime sync"
                            description="See and update events in realtime."
                            icon={<Sync color="primary" />}
                        />
                        <FeatureBlock
                            title="Google Calendar Automations"
                            description="Create, update or delete calendar event when something changes in your workspace."
                            icon={<Settings color="primary" />}
                        />
                        <FeatureBlock
                            title="AI Notetaker"
                            description="Capture meeting notes, including summaries, action items, and more."
                            icon={<Note color="primary" />}
                        />
                    </Stack>

                    <Divider sx={{ my: 3, borderColor: '#e0e0e0' }} />

                    <Typography variant="subtitle1" fontWeight="bold" gutterBottom>
                        Commands
                    </Typography>
                    <Stack spacing={2}>
                        <FeatureBlock
                            title="Open Google Calendar"
                            description="Quickly launch Google Calendar with just a couple of keystrokes."
                            icon={<Launch color="primary" />}
                        />
                        <FeatureBlock
                            title="Show Calendar Schedule"
                            description="Check your schedule and join meetings."
                            icon={<CalendarToday color="primary" />}
                        />
                    </Stack>
                </Paper>
            </Box>
        </Box>
    );
};

const FeatureBlock = ({ title, description, icon, actionButton }) => (
    <Stack
        direction="row"
        alignItems="flex-start"
        justifyContent="space-between"
        spacing={2}
    >
        <Box display="flex" alignItems="center" gap={2}>
            {icon}
            <Box>
                <Typography variant='h3'>{title}</Typography>
                <Typography variant="small" color="text.secondary">
                    {description}
                </Typography>
            </Box>
        </Box>
        {actionButton && <Box>{actionButton}</Box>}
    </Stack>
);

export default GoogleCalendarIntegrationPage;
